import { config, language } from "@chef/constants";

export const intl = (
  {
    no: {
      REACTIVATE_YOUR_ACCOUNT_TO_CHOOSE_DISHES:
        "Aktiver abonnementet på nytt for å legge til en middag",
      ORDER_DELIVERY_TO_CHOOSE_DISHES:
        "Bestill levering for å legge til en middag",
      CHOOSE_DISHES: "Velg middager",
      ADD: "Legg til",
      CHOOSE_BETWEEN_N_DISHES: (n: number) => `Velg mellom ${n} middager`,
      DISH: "rett",
      ADD_UP_TO_N_DISHES: `Du kan velge opptil ${config.order.maxMeals} middager`,
    },
    se: {
      REACTIVATE_YOUR_ACCOUNT_TO_CHOOSE_DISHES:
        "Återaktivera prenumerationen för att lägga till en middag",
      ORDER_DELIVERY_TO_CHOOSE_DISHES:
        "Boka leveransen för att lägga till en middag",
      CHOOSE_DISHES: "Välj middagar",
      ADD: "Lägg till",
      CHOOSE_BETWEEN_N_DISHES: (n: number) => `Välj mellan ${n} middagar`,
      DISH: "rätt",
      ADD_UP_TO_N_DISHES: `Välj upp till ${config.order.maxMeals} middagar`,
    },
    dk: {
      REACTIVATE_YOUR_ACCOUNT_TO_CHOOSE_DISHES:
        "Genaktiver abonnementet for at tilføje en ret",
      ORDER_DELIVERY_TO_CHOOSE_DISHES: "Bestil levering for at tilføje en ret",
      CHOOSE_DISHES: "Vælg retter",
      ADD: "Tilføj",
      CHOOSE_BETWEEN_N_DISHES: (n: number) => `Frit valg mellem ${n} retter`,
      DISH: "ret",
      ADD_UP_TO_N_DISHES: `Du kan vælge op til ${config.order.maxMeals} retter`,
    },
  } as const
)[language];
